/** Redux / API key for the gate: "did-you-buy-medicine-in-the-pharmacy-today" */
export const ALPHIGA_GATE_STATE_KEY = "bought_medicine";

export const ALPHIGA_COMPANY_ID = "631b932870ed43a89dbfe666"; // Alphiga
export const ALPHIGA_FRANCE_COMPANY_ID = "69b01f4384d31f84b961695c"; // Alphega - France
export const ALPHIGA_NETHERLANDS_COMPANY_ID = "69f359caca2631baf38eeaae"; // Alphega - Netherlands
export const ALPHIGA_ROMANIA_COMPANY_ID = "69ef31c80b47fa006045bdcc"; // Alphega - Romania
export const ALPHIGA_CZECH_COMPANY_ID = "69fddec81b03d25fb29a1555"; // Alphega - Czech Republic
export const ALPHIGA_SPAIN_COMPANY_ID = "69fddb0d1b03d25fb299e6e0"; // Alphega - Spain

export const ALPHIGA_FOLLOWUP_CONFIG_BY_COMPANY = {
  /** Alphega — UK */
  [ALPHIGA_COMPANY_ID]: {
    followUpSectionIntroId: "were-you-asked-any-of-the-following",
    followUpQuestions: [
      {
        messageId: "who-is-the-medicine-for",
        stateKey: "medicine_for",
      },
      {
        messageId: "what-are-your-symptoms",
        stateKey: "symptoms",
      },
      {
        messageId: "how-long-you-had-the-symptoms",
        stateKey: "symptoms_duration",
      },
      {
        messageId: "what-action-you-have-already-taken",
        stateKey: "action_taken",
      },
      {
        messageId: "are-you-taking-any-other-medication",
        stateKey: "other_medication",
      },
    ],
  },
  /** Alphega — France */
  [ALPHIGA_FRANCE_COMPANY_ID]: {
    followUpQuestions: [
      {
        messageId: "did-you-wait-more-than-10-minutes-to-be-served",
        stateKey: "wait_time",
      },
      {
        messageId: "were-the-products-you-wanted-in-stock",
        stateKey: "products_in_stock",
      },
      {
        messageId: "were-the-staff-friendly-and-helpful",
        stateKey: "staff_friendly",
      },
      {
        messageId: "did-you-receive-any-advice-about-your-medicines",
        stateKey: "received_advice",
      },
    ],
  },
  /** Alphega — Netherlands */
  [ALPHIGA_NETHERLANDS_COMPANY_ID]: {
    followUpQuestions: [
      {
        messageId: "did-you-wait-more-than-10-minutes-to-be-served",
        stateKey: "wait_time",
      },
      {
        messageId: "were-the-products-you-wanted-in-stock",
        stateKey: "products_in_stock",
      },
      {
        messageId: "were-the-staff-friendly-and-helpful",
        stateKey: "staff_friendly",
      },
      {
        messageId: "did-you-receive-any-advice-about-your-medicines",
        stateKey: "received_advice",
      },
    ],
  },
  /** Alphega — Romania */
  [ALPHIGA_ROMANIA_COMPANY_ID]: {
    followUpQuestions: [
      {
        messageId: "did-you-wait-more-than-10-minutes-to-be-served",
        stateKey: "wait_time",
      },
      {
        messageId: "were-the-products-you-wanted-in-stock",
        stateKey: "products_in_stock",
      },
      {
        messageId: "were-the-staff-friendly-and-helpful",
        stateKey: "staff_friendly",
      },
      {
        messageId: "did-you-receive-any-advice-about-your-medicines",
        stateKey: "received_advice",
      },
    ],
  },
  /** Alphega — Czech Republic */
  [ALPHIGA_CZECH_COMPANY_ID]: {
    followUpQuestions: [
      {
        messageId: "did-you-wait-more-than-10-minutes-to-be-served",
        stateKey: "wait_time",
      },
      {
        messageId: "were-the-products-you-wanted-in-stock",
        stateKey: "products_in_stock",
      },
      {
        messageId: "were-the-staff-friendly-and-helpful",
        stateKey: "staff_friendly",
      },
      {
        messageId: "did-you-receive-any-advice-about-your-medicines",
        stateKey: "received_advice",
      },
    ],
  },
  /** Alphega — Spain */
  [ALPHIGA_SPAIN_COMPANY_ID]: {
    followUpQuestions: [
      {
        messageId: "did-you-wait-more-than-10-minutes-to-be-served",
        stateKey: "wait_time",
      },
      {
        messageId: "were-the-products-you-wanted-in-stock",
        stateKey: "products_in_stock",
      },
      {
        messageId: "were-the-staff-friendly-and-helpful",
        stateKey: "staff_friendly",
      },
      {
        messageId: "did-you-receive-any-advice-about-your-medicines",
        stateKey: "received_advice",
      },
    ],
  },
};

export const ALPHIGA_ENABLED_COMPANY_IDS = Object.keys(
  ALPHIGA_FOLLOWUP_CONFIG_BY_COMPANY,
);

export const ALPHIGA_CLASSIC_CLEAR_KEYS = [
  "medicine_for",
  "symptoms",
  "symptoms_duration",
  "action_taken",
  "other_medication",
];

/** Follow-up + classic keys cleared when resetting Alphiga follow-ups (not the gate key). */
export function getAlphigaFollowUpClearKeys(companyId) {
  const fromConfig = getAlphigaFollowUpQuestions(companyId).map(
    (q) => q.stateKey,
  );
  return [...new Set([...ALPHIGA_CLASSIC_CLEAR_KEYS, ...fromConfig])];
}

export function getAlphigaFollowUpConfig(companyId) {
  return ALPHIGA_FOLLOWUP_CONFIG_BY_COMPANY[companyId];
}

export function getAlphigaFollowUpQuestions(companyId) {
  return getAlphigaFollowUpConfig(companyId)?.followUpQuestions ?? [];
}

/** Keys cleared on “No” to gate or when reopening gate “Yes” (excludes `ALPHIGA_GATE_STATE_KEY`). */
export function getAlphigaAllNoClearKeys(companyId) {
  return getAlphigaFollowUpClearKeys(companyId);
}

export function resolveCompanyId(webRatingData) {
  if (!webRatingData || typeof webRatingData !== "object") {
    return typeof window !== "undefined"
      ? localStorage.getItem("company_id") || ""
      : "";
  }
  const fromApi = webRatingData.company_id;
  if (fromApi != null && String(fromApi).trim() !== "") {
    return String(fromApi).trim();
  }
  return typeof window !== "undefined"
    ? localStorage.getItem("company_id") || ""
    : "";
}

export function isAlphigaEnabledCompany(companyId) {
  return ALPHIGA_ENABLED_COMPANY_IDS.includes(companyId);
}
